/**
 * Helper to log reason when a Save API call is skipped in admin view.
 */
export const logSaveSkipReason = (sectionName: string, reason: string, context?: Record<string, unknown>) => {
  // TODO: remove after verification
  console.info(`[${sectionName} Save] skipped: ${reason}, context:`, context);
};
